<div *ngIf="this.session">
  <uploader-component (uploaded)="updateTableData()"></uploader-component>
  <data-table-component [activeFileRecordList]="activeFileRecordList" [previousFileRecordList]="previousFileRecordList" (updateTable)="updateTableData()"></data-table-component>
</div>
